var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcViewMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "34px",
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "01 Icons/ic-view-map") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "01-Icons/ic-view-map",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uF279",
    transform: "translate(6.875000, 9.512695)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5,15.4716797 L6.75,13.5380859 L6.75,0.0029296875 L13.5,1.93652344 L13.5,15.4716797 Z M14.625,15.4365234 L14.625,1.83105469 L19.0898438,0.0732421875 C19.3945312,-0.0439453125 19.6523438,-0.0205078125 19.8632812,0.143554688 C20.0976562,0.307617188 20.2265625,0.541992188 20.25,0.846679688 L20.25,12.6240234 C20.2265625,12.9755859 20.0507812,13.2333984 19.7226562,13.3974609 L14.625,15.4365234 Z M0.52734375,2.07714844 L5.625,0.0380859375 L5.625,13.6435547 L1.16015625,15.4365234 C0.85546875,15.5302734 0.59765625,15.4951172 0.38671875,15.3310547 C0.15234375,15.1669922 0.0234375,14.9326172 0,14.6279297 L0,2.85058594 C0.0234375,2.49902344 0.19921875,2.24121094 0.52734375,2.07714844 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcViewMap);
export default __webpack_public_path__ + "static/media/ic-view-map.0786fc6d9173f0e75e774e9a79de88ce.svg";
export { ForwardRef as ReactComponent };